export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8386.bf4eea5a.jpg";